import React, { useState, useEffect, useRef } from 'react'
import '../../styles/style.css';
import '../../styles/navbar.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL, handleStorage } from '../../constant/Utility'
import axios from 'axios';
import Swal from 'sweetalert2';
import karunaposter from '../../assets/img/banner/high_karuna.jpg'
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
// karuna_web_backgroundfinal.png
function Login() {

  const base_url = BASE_URL;
  let navigate = useNavigate();
  const location = useLocation();

  var form_data = new FormData();
  const page_id = localStorage.getItem("page_id");
  const [pageloading, setLoading] = useState(false);
  const [type, setType] = useState(false);
  const [step, setStep] = useState(0);
  const [message, setMessage] = useState("");
  const [event, setEvent] = useState(location.state?.eventId);
  const { register, formState: { errors }, handleSubmit, reset, getValues } = useForm();
  const { register: fReg, formState: { errors: fErr }, handleSubmit: fhandleSubmit, reset: fReset } = useForm();
  const [mail, setMail] = useState();
  const [timer, setTimer] = useState();

  function handleOnSubmit(data) {
    // setEvent(location.state?.eventId);
    setLoading(true);

    form_data = data;

    axios({
      method: "post",
      url: base_url + "user/login",
      data: form_data,
      headers: { "Content-Type": "multipart/form-data" },
    }).then(response => {
      setLoading(false);
      login_info(response.data);
      Swal.fire({
        text: 'Logged in successfully',
        toast: true,
        showConfirmButton: false,
        timer: 1500,
        icon: 'success',
        position: 'top-end'
      })
    }, error => {
      setLoading(false);
      setMessage(error.response.data.detail.detail);
    }).catch(error => {
      setLoading(false);
    })
  }
  useEffect(() => {
    handleStorage(page_id);
    setMessage("");
    step == 0 && setMail();
    step !== 2 && setTimer();
  }, [step])

  const Loading = (status) => {
    if (status) {
      // document.body.setAttribute('style','overflow:hidden;height:100vh');
      return (
        <div className='app_content'>
          <div className="loading">Loading&#8230;</div>
        </div>
      )
    } else {
      document.body.setAttribute('style', 'overflow:visible;');
    }
  }

  function login_info(logData) {
    if (logData?.access_token) {
      sessionStorage.setItem('token', logData.access_token);
      sessionStorage.setItem('user_role', logData.role_id);
      axios({
        method: 'GET',
        url: base_url + 'user/getAccessRights',
        headers: { "Content-Type": "application/json", "Authorization": `bearer ${logData.access_token}` }
      }).then(response => {
        navigate('/admin/dashboard');
      }, error => {
        if (event != null) {
          navigate('/high_octavez/Event_details',
            { state: { event } })
        } else if (page_id == 0) {
          navigate('/home');
        } else if (page_id == 1) {
          navigate('/high_octavez/home')
        } else {
          navigate('/');
        }
      });

      // if (serviceData.role_id == 1 || serviceData.role_id == 2 || serviceData.role_id == 9) {
      //   navigate('/admin/dashboard');
      // }else{
      //   if (event != null) {
      //     navigate('/high_octavez/Event_details',
      //       { state: { event } })
      //   }else if (page_id== 0) {
      //     navigate('/home');
      //   } else if (page_id== 1) {
      //     navigate('/high_octavez/home')
      //   } else {
      //     navigate('/');
      //   }
      // } 
    }
  }

  const back = () => {
    if (page_id == 0) {
      navigate("/home");
    } else if (page_id == 1) {
      navigate("/high_octavez/home");
    } else {
      navigate("/");
    }
  }

  const changeMail = (event) => {
    setMail(event.target.value);
  }

  useEffect(() => {
    if (timer <= 30 && timer && step == 2) {
      setTimeout(() => {
        setTimer(timer - 1)
      }, 1000);
    }
  }, [timer])

  const sendOTP = () => {
    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail)) {
      setLoading(true);
      axios.post(`${BASE_URL}user/pinGenerate`, { email_id: mail }).then((response) => {
        setLoading(false);
        toast.success('OTP sent successfully', {
          position: "top-right",
          autoClose: 1700,
          type: 'success',
          hideProgressBar: true,
          draggable: false
        });
        setTimer(30);
        setStep(2);
      }).catch((error) => {
        setLoading(false);
        toast('The mail ID is not registered', {
          position: "top-right",
          autoClose: 1700,
          type: 'error',
          hideProgressBar: true,
          draggable: false
        });
      })
    }
  }
  const forgotPWD = (data) => {
    data.email_id = mail;
    setLoading(true);
    axios.put(`${base_url}user/changeoldpassword`, data).then((response) => {
      setMessage("");
      setLoading(false);
      toast.success('Password changed', {
        position: "top-right",
        autoClose: 1700,
        type: 'success',
        hideProgressBar: true,
        draggable: false
      });
      setStep(0);
    }).catch((error) => {
      setLoading(false);
      if (error.response.status == 422) {
        setMessage("Invalid pin")
      } else {
        setMessage(error.response.data.detail.detail);
      }
    });
  }

  return (
    <div className='karuna_part'>
      <ToastContainer />
      <div className='row g-0'>
        <div className='col-lg-7 bg-dark shadow-custum'>
          <img src={karunaposter} alt="karuna" className='img-fluid h-100' />
        </div>
        <div className='col-lg-5'>
          <section id="login_arae" className="d-flex align-items-center justify-content-center min vh-100">
            {step == 0 ?
              <div className="">
                <div className="">
                  <div className=" col-12">
                    <div className="section_heading mb-0">
                      <h3 style={{ fontStyle: 'normal' }}>Login your account</h3>
                      <h2 style={{ fontStyle: 'normal' }}>Join our <span className="color_big_heading">community</span> to help people</h2>
                    </div>
                  </div>
                </div>
                <div className="row mx-auto justify-content-center">
                  <div className="col-lg-10 ">
                    <div className="author_form_area">
                      {/* {login_info()} */}
                      <h4 className="text-danger text-center">{message}</h4>
                      <form id="author_form" onSubmit={handleSubmit(handleOnSubmit)}>
                        <div className="form-group">
                          <input style={{ fontStyle: 'normal' }} type="text" className="custum-control form-control mt-3" placeholder="Email" name='username'
                            {...register("username", { required: true, onChange: () => setMessage('') })}
                            aria-invalid={errors?.username ? "true" : "false"} />
                          {errors?.username?.type === 'required' && <div className='text-danger'>Email is required</div>}
                        </div>
                        <div className="form-group mt-3">
                          <div className='input-group'>
                            <input style={{ fontStyle: 'normal' }} autoComplete='off' type={type ? "text" : "password"} className="custum-control form-control" placeholder="Password" name='password'
                              {...register("password", { required: true, onChange: () => setMessage('') })}
                              aria-invalid={errors?.password ? "true" : "false"} />
                            <span className='input-group-text custum-control eye_part'><i className={type ? "fas fa-eye-slash" : "fas fa-eye"} onClick={() => { setType(!type) }} style={{ cursor: 'pointer' }} ></i></span>
                          </div>
                          {errors?.password?.type === 'required' && <div className='text-danger'>Password is required</div>}
                        </div>
                        <div className="author_submit_form" >
                          <button className="btn btn-secondary mb-3 mx-3" type="button" onClick={back}> Back</ button>
                          <button className="btn btn_theme mb-3" type="submit" >Login</ button><br />
                          <div className='mt-2'>
                            <Link className='medium' onClick={() => (setStep(1), fReset())}><u>Forgot password</u></Link>
                            <p className='mb-3 p-0'>Don't have an account? <Link className='fw-bold' to="/register">Register now</Link></p>
                          </div>
                          {/* <button className='btn link-danger fw-bold' type='button' onClick={back}>Back to home</button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              :
              <div >
                <div >
                  <div className=" col-12">
                    <div className="section_heading mb-0">
                      <h2 className='h3' style={{ fontStyle: 'normal' }}>Forgot Password ?</h2>
                    </div>
                  </div>
                </div>
                <div className="row mx-auto justify-content-center">
                  <div className="col-lg-12">
                    <div className='text-center'>
                      <h5 className='text-center text-danger mt-1'>{message}</h5>

                      {/* forgot password */}
                      <div className='text-center mb-3'>
                        <input disabled={step == 2} type="text" value={mail} className="form-control forgot-control emailControl mt-3" placeholder="Email" name='email_id' onChange={changeMail} />
                        {timer ? <div className='text-primary small text-start'>Resend OTP in 0:{timer}</div> : ''}
                        {(mail && !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail))) && <div className='text-danger text-start'>Enter valid Email ID</div>}
                        {step == 1 && <button type='button' className='btn optbtn mt-3' onClick={sendOTP} >Get OTP</button>}
                      </div>
                      {step == 2 && <form id="author_form" onSubmit={fhandleSubmit(forgotPWD)}>
                        <div className="form-group">
                          <input type="text" className=" form-control forgot-control mt-3" placeholder="OTP" autoComplete='off' name='pin'
                            {...fReg("pin", { required: true })}
                            aria-invalid={fErr?.username ? "true" : "false"} />
                          {fErr?.pin?.type === 'required' && <div className='text-danger mt-1' style={{ fontSize: '14px' }}>OTP is required</div>}
                        </div>
                        <div className="form-group mt-3">
                          <div className='input-group'>
                            <input autoComplete='off' type={type ? "text" : "password"} className=" form-control forgot-control" placeholder="Password" name='password'
                              {...fReg("password", { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/ })}
                              aria-invalid={fErr?.password ? "true" : "false"} />
                            <span className='input-group-text forgot-control'><i className={type ? "fas fa-eye-slash" : "fas fa-eye"} onClick={() => { setType(!type) }} style={{ cursor: 'pointer' }} ></i></span>
                          </div>
                          {fErr?.password?.type === 'pattern' && <div className='text-danger mt-1' style={{ fontSize: '14px' }}>password field should contains <br />- at least one uppercase and one lowercase <br />- One special characters <br />- One number and minimum eight characters</div>}
                        </div>
                        <div className="mt-3" >
                          <button className="btn optbtn mb-3 mx-3" type="button" disabled={/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail) && !timer ? false : true} onClick={sendOTP}> Resend OTP</ button>
                          <button className="btn btn_theme mb-3" type="submit" >Confirm</ button><br /></div>
                      </form>}
                      <div className=' fw-bold'>
                        <Link onClick={() => (setStep(0), fReset())}><u>Login</u></Link>
                      </div>
                      <p className='mb-3 p-0 '>Don't have an account? <Link className='fw-bold' to="/register">Register now</Link></p>

                    </div>
                  </div>
                </div>
              </div>
            }
          </section>

        </div>
        {Loading(pageloading)}
      </div>
    </div>
  )
}

export default Login